import type { ActiveWorkflow } from '@/types/conversations'

const TERMINAL_WORKFLOW_STATUSES = ['paused', 'reverted', 'completed', 'completed_with_failures', 'interrupted']

const STEP_DISPLAY_NAMES: Record<string, string> = {
  preflight_sync_upstream: 'Update Cayu Framework',
  classify_deploy_tier: 'Classify Deploy Tier',
  preflight_compile: 'Check Backend',
  preflight_migrations: 'Check Migrations',
  preflight_frontend_build: 'Check Frontend Build',
  deploy: 'Deploy',
  verify_health: 'Verify Health',
  verify_endpoints: 'Verify Endpoints',
  verify_logs: 'Verify Logs',
}

export function formatStepId(stepId: string): string {
  return STEP_DISPLAY_NAMES[stepId] ?? stepId.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
}

export function getWorkflowTitle(name: string, description?: string): string {
  if (name === 'remove_mobile') return 'Removing mobile app'
  return description || name
}

/**
 * Detect if a workflow is currently in progress.
 * Reads from the ActiveWorkflow model (broadcast via workflow_progress_update).
 */
export function isWorkflowInProgress(activeWorkflow: ActiveWorkflow | null | undefined): boolean {
  if (!activeWorkflow) return false
  if (['completed', 'failed', 'interrupted'].includes(activeWorkflow.status)) return false
  const wfStatus = activeWorkflow.workflow_status
  if (wfStatus && TERMINAL_WORKFLOW_STATUSES.includes(wfStatus)) return false
  return activeWorkflow.status === 'processing' || activeWorkflow.steps_data?.some(s => s.status === 'in_progress')
}

const PRODUCTION_WORKFLOWS = ['deploy_to_production', 'remove_mobile', 'seo_optimize']

export function isProductionWorkflowStarting(activeWorkflow: ActiveWorkflow | null | undefined): boolean {
  return !!activeWorkflow &&
    activeWorkflow.status === 'processing' &&
    PRODUCTION_WORKFLOWS.includes(activeWorkflow.workflow_name)
}

/**
 * Detect if the active workflow is blocking the message input.
 * Returns false when all active/remaining steps have non_blocking: true.
 */
export function isWorkflowBlocking(activeWorkflow: ActiveWorkflow | null | undefined): boolean {
  if (!activeWorkflow || !activeWorkflow.steps_data) return false
  return activeWorkflow.steps_data.some(s =>
    (s.status === 'in_progress' || s.status === 'pending') && !s.non_blocking
  )
}
